import { formatAppDisplayName } from "./branding.logic";

export const APP_BASE_NAME = "Forge";

const hostedAppChannel = import.meta.env.VITE_HOSTED_APP_CHANNEL?.trim().toLowerCase();

/** The baked hosted release channel ("latest" | "nightly"), or null outside static hosting. */
export const HOSTED_APP_CHANNEL =
  hostedAppChannel === "latest" || hostedAppChannel === "nightly" ? hostedAppChannel : null;

const HOSTED_APP_CHANNEL_LABEL =
  HOSTED_APP_CHANNEL === "nightly" ? "Nightly" : HOSTED_APP_CHANNEL === "latest" ? "Latest" : null;

export const APP_STAGE_LABEL = HOSTED_APP_CHANNEL_LABEL ?? (import.meta.env.DEV ? "Dev" : "Alpha");

// Hosted channels label the display name ("Forge (Nightly)"); latest stays
// plain, and builds without a baked channel keep the bare name they always had.
export const APP_DISPLAY_NAME = HOSTED_APP_CHANNEL_LABEL
  ? formatAppDisplayName({ baseName: APP_BASE_NAME, stageLabel: APP_STAGE_LABEL })
  : APP_BASE_NAME;

export const APP_VERSION = import.meta.env.APP_VERSION || "0.0.0";
